<template>
  <div>
    <list />
  </div>
</template>

<script>
  import {
    // BCard,
    BTab,
    BTabs
    // BCardText, BButton,
  } from 'bootstrap-vue'
  import List from './components/Index.vue'

  export default {
    components: {
      // BCard,
      // BCardText,
      // BButton,
      BTab,
      BTabs,
      List
    },
    data: () => ({
      data: []
    }),
    watch: {
      '$i18n.locale': function localeChangeHandler() {}
    },
    mounted() {},
    methods: {},
    setup() {
      const permissionType = 'chat-agent'
      return { permissionType }
    }
  }
</script>
